// Мини-замена mobx-react-lite `observer`, под наш стек (React 15 без хуков,
// rxjs@5.5.x с `Subject`). Принимает класс-компонент и список стора(ов),
// возвращает обёртку, которая подписывается на их `subject` и форсит
// перерендер при `.next()`.
//
// Использование:
//
//   class CartView extends React.Component {
//     render() { ... this.props.cart ... }
//   }
//   export default observer(CartView, ['cartStore']);
//
// Стора берутся из контекста (rootStore), который инжектится через React
// context-провайдер `<StoresProvider />`. Имена `'cartStore'` и т.п. — это
// ключи RootStore.

import React from 'react';
import PropTypes from 'prop-types';

export function observer(WrappedComponent, storeNames) {
  const names = Array.isArray(storeNames) ? storeNames : [storeNames];

  class Observer extends React.Component {
    constructor(props, context) {
      super(props, context);
      this._subscriptions = [];
    }

    componentWillMount() {
      const root = this.context.rootStore;
      names.forEach((n) => {
        const store = root[n];
        if (store && store.subject && store.subject.subscribe) {
          const sub = store.subject.subscribe(() => this.forceUpdate());
          this._subscriptions.push(sub);
        }
      });
    }

    componentWillUnmount() {
      this._subscriptions.forEach((s) => {
        try { s.unsubscribe(); } catch (e) { /* noop */ }
      });
      this._subscriptions = [];
    }

    render() {
      const root = this.context.rootStore;
      const injected = {};
      names.forEach((n) => {
        // Удобный alias: cartStore → props.cart
        const propName = n.replace(/Store$/, '');
        injected[propName] = root[n];
        injected[n] = root[n];
      });
      return React.createElement(WrappedComponent, Object.assign({}, this.props, injected, { rootStore: root }));
    }
  }

  Observer.contextTypes = { rootStore: PropTypes.object };
  Observer.displayName = `observer(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return Observer;
}

export class StoresProvider extends React.Component {
  getChildContext() {
    return { rootStore: this.props.rootStore };
  }
  render() { return React.Children.only(this.props.children); }
}
StoresProvider.childContextTypes = { rootStore: PropTypes.object };
StoresProvider.propTypes = {
  rootStore: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/shared/observer.js